import { Link } from 'react-router-dom';
import { Search, Instagram, Linkedin, Youtube } from 'lucide-react';
import leilizeLogo from '@/assets/leilize-logo.png';

const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL || 'contato@leilize.com';

export function Footer() {
  return (
    <footer className="border-t border-border/50 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="space-y-4 lg:col-span-1">
            <div className="flex items-center">
              <img src={leilizeLogo} alt="LEILIZE" className="h-[3.8rem] w-auto" />
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Análise inteligente de carros de leilão. Compre com segurança, economize com inteligência.
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-3 pt-2">
              <a 
                href="#" 
                className="w-9 h-9 rounded-lg bg-muted flex items-center justify-center hover:bg-primary/10 hover:text-primary transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a 
                href="#" 
                className="w-9 h-9 rounded-lg bg-muted flex items-center justify-center hover:bg-primary/10 hover:text-primary transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a 
                href="#" 
                className="w-9 h-9 rounded-lg bg-muted flex items-center justify-center hover:bg-primary/10 hover:text-primary transition-colors"
                aria-label="YouTube"
              >
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Produto */}
          <div>
            <h3 className="font-heading font-semibold mb-4 text-foreground">Produto</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/como-funciona" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Como Funciona
                </Link>
              </li>
              <li>
                <Link to="/precos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Preços
                </Link>
              </li>
              <li>
                <Link to="/demo" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Demo
                </Link>
              </li>
            </ul>
          </div>

          {/* Recursos */}
          <div>
            <h3 className="font-heading font-semibold mb-4 text-foreground">Recursos</h3>
            <ul className="space-y-3">
              <li>
                <span className="text-sm text-muted-foreground/60">Blog (em breve)</span>
              </li>
              <li>
                <a 
                  href={`mailto:${CONTACT_EMAIL}`}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-heading font-semibold mb-4 text-foreground">Legal</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/privacidade" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Privacidade
                </Link>
              </li>
              <li>
                <Link to="/termos" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Termos de Uso
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-border/50">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-muted-foreground text-center md:text-left">
              © {new Date().getFullYear()} LEILIZE. Todos os direitos reservados.
            </p>
            <p className="text-xs text-muted-foreground/60 text-center md:text-right">
              As estimativas não constituem aconselhamento financeiro.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
